import styled, { css } from 'styled-components';

import { Button } from '@/components/ui/Button/Button';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { Z_INDEX } from '@/constants/z-index';
import { flexCenterAligned, flexColumn } from '@/styles/common';

export const StatusModalOverlay = styled.div<{ $zIndex?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ $zIndex }) => $zIndex || Z_INDEX.MODAL};
  width: 100%;
  height: 100%;
  ${flexCenterAligned};
  pointer-events: all;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
`;

export const StatusModalCard = styled.div`
  background: var(--bg-main);
  width: 100%;
  max-width: 440px;
  min-height: auto;
  border-radius: 14px;
  padding: 40px;
  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 25px;
    gap: 20px;
  }

  ${flexColumn};
  justify-content: space-between;
  align-items: center;
  position: relative;

  gap: 25px;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    margin-inline: 36px 35px;
  }
`;

export const StatusIconWrapper = styled.div<{
  $isStatus: boolean;
  $isTransparent?: boolean;
}>`
  width: ${({ $isStatus }) => ($isStatus ? '60px' : '45px')};
  height: ${({ $isStatus }) => ($isStatus ? '60px' : '45px')};
  margin: ${({ $isStatus }) => !$isStatus && '8px'};
  @media (max-width: ${BREAKPOINTS.mobile}) {
    width: 45px;
    height: 45px;
  }

  ${flexCenterAligned};
  background: ${({ $isStatus, $isTransparent }) =>
    $isTransparent
      ? 'transparent'
      : $isStatus
        ? 'var(--textAndLabels-main)'
        : 'var(--system-red)'};
  border-radius: 100px;
`;

export const StatusModalTitle = styled.h3`
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  color: var(--textAndLabels-main);
`;

export const StatusModalSubtitle = styled.p`
  font-size: 15px;
  text-align: center;
  color: var(--textAndLabels-tertiary);
`;

export const ModalExtraContentPaymentSubtitle = styled.p`
  font-size: 15px;
  text-align: center;
  color: var(--textAndLabels-tertiary);
`;

export const StatusPrimaryButton = styled(Button).attrs({
  type: 'button',
  variant: 'modalPrimary',
  size: 'm'
})`
  width: 100%;
  max-width: 224px;
  min-height: 44px;
  border-radius: 28px;
  cursor: pointer;
  ${flexCenterAligned};
`;

export const StatusPrimaryButtonLabel = styled(Typography).attrs({
  variant: 'title4'
})<{ $isDark?: boolean }>`
  color: ${({ $isDark }) =>
    $isDark ? 'var(--textAndLabels-main)' : 'var(--bg-main)'};
`;

export const StatusCloseButton = styled.button.attrs({
  type: 'button'
})`
  position: absolute;
  right: 40px;
  top: 29px;
  background: none;
  border: none;
  ${flexCenterAligned};
  cursor: pointer;
`;

export const ModalBox = styled.div<{ $zIndex?: number }>`
  border-radius: 28px;
  padding: 40px;
  width: 100%;
  max-width: 384px;
  height: 222px;
  background: var(--bg-main);
  ${flexColumn};
  gap: 30px;
  ${({ $zIndex }) =>
    $zIndex &&
    css`
      z-index: ${$zIndex};
    `}
  align-items: center;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    margin-inline: 10px 11px;
    padding: 25px;
    justify-content: space-between;
    gap: 20px;
    max-height: fit-content;
  }
`;

export const ModalContent = styled.div`
  ${flexColumn};
  gap: 10px;
  align-items: center;
  width: 100%;

  @media (max-width: ${BREAKPOINTS.mobile}) {
  }
`;

export const ModalActions = styled.div`
  width: 100%;
  ${flexCenterAligned};
  gap: 10px;
`;

export const ModalTitle = styled.h3`
  font-weight: 700;
  font-size: 18px;
  color: var(--textAndLabels-main);
`;

export const ModalSubtitle = styled.p`
  font-size: 15px;
  width: 100%;
  max-width: 304px;
  color: var(--textAndLabels-tertiary);
  text-align: center;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    max-width: 100%;
  }
`;

export const CloseButton = styled.button.attrs({ type: 'button' })`
  border: 2px solid var(--textAndLabels-main);
  font-weight: 500;
  font-size: 14px;
  color: var(--textAndLabels-main);
  background: transparent;
  border-radius: 28px;
  width: 100%;
  max-width: 147px;
  min-height: 44px;
  cursor: pointer;
`;

export const AddBalanceButton = styled.button.attrs({ type: 'button' })<{
  $isDark?: boolean;
}>`
  border-radius: 28px;
  width: 100%;
  max-width: 147px;
  min-height: 44px;
  border: none;
  font-weight: 500;
  font-size: 14px;
  color: ${({ $isDark }) =>
    $isDark ? 'var(--textAndLabels-main)' : 'var(--bg-main)'};
  background: var(--system-blue);
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: var(--system-deepBlue);
  }
`;

export const ConfirmButton = styled(Button)`
  width: 100%;
`;

export const ContentWrapper = styled.div`
  ${flexColumn};
  gap: 10px;
`;
